<div class="modal-header">
  <h5 class="modal-title">{{title}}</h5>
  <button type="button" class="close basic-close" data-dismiss="modal" aria-label="Close" (click)="onClose()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<form autocomplete="off" [formGroup]="form" (ngSubmit)="onConfirme()">
  <div class="modal-body">
    <div class="col-md-12">
      <!-- DÉTAILS RESERVES AU CLIENT -->
      <div class="row">
        <span class="badge badge-secondary my-2 f-14 width">
          Détails réservés au client
        </span>
      </div>
      <div class="form-group">
        <div class="row mb-2">
          <div class="col-md-3">
            <label for="customer">Client <span class="asterix">*</span></label>
            <app-entity-finder id="customer" [class]="'Customer'" [groups]="['customer']" [required]="true"
              (uuid)="setCustomerUuid($event)" [selected]="customerSelected" [disabled]="edit"
              [placeholder]="'Sélectionnez un client'">
            </app-entity-finder>
          </div>
          <div class="col-md-3">
            <label>Forme juridique</label>
            <input type="text" class="form-control p-2 text-uppercase font-weight-bold text-secondary"
              [value]="customer?.type" readonly>
          </div>
          <div class="col-md-3">
            <label>Contact</label>
            <input type="text" class="form-control p-2 text-uppercase font-weight-bold text-secondary"
              [value]="customer?.telephone" readonly>
          </div>
          <div class="col-md-3">
            <label>Émail</label>
            <input type="text" class="form-control p-2 text-uppercase font-weight-bold text-secondary"
              [value]="customer?.user?.email" readonly>
          </div>
        </div>
      </div>

      <!-- DÉTAILS RESERVER AUX BIENS -->
      <div class="row">
        <span class="badge badge-secondary my-2 f-14 width">
          Détails réservés aux biens
        </span>
      </div>
      <div class="form-group">
        <div class="row mb-2">
          <div class="col-md-3">
            <label for="numero">Numéro du dossier </label>
            <input type="text" formControlName="numero" class="form-control" id="numero"
              placeholder="Numéro du dossier"
              [ngClass]="{'is-invalid': submit && f.numero.errors,'is-valid': submit && f.numero.valid}">
            <div class="invalid-feedback" *ngIf="submit && f.numero.errors">
              <div *ngIf="f.numero.errors.required">{{required.novide}}</div>
            </div>
          </div>
          <div class="col-md-3">
            <label for="date">Date d'ouverture <span class="asterix">*</span></label>
            <input type="date" (ngModelChange)="addEcheanceFolder()" formControlName="date" class="form-control" id="date" [ngClass]="{
              'is-invalid': submit && f.date.errors,
              'is-valid': submit && f.date.valid
            }">
            <div class="invalid-feedback" *ngIf="submit && f.date.errors">
              <div *ngIf="f.date.errors.required">{{required.novide}}</div>
            </div>
          </div>
          <div class="col-md-3">
            <label for="motif">Motif d'ouverture <span class="asterix">*</span></label>
            <select (change)="onChangeMotif($event)" class="form-control" id="motif" formControlName="motif" [ngClass]="{
                'is-invalid': submit && f.motif.errors,
                'is-valid': submit && f.motif.valid
              }">
              <option *ngFor="let item of motifRow" [value]="item.value">{{item.label}}</option>
            </select>
            <div class="invalid-feedback" *ngIf="submit && f.motif.errors">
              <div *ngIf="f.motif.errors.required">{{required.novide}}</div>
            </div>
          </div>
          <div class="col-md-3">
            <label for="charge">Chargé d'affaire</label>
            <select class="form-control" id="charge" formControlName="charge">
              <option *ngFor="let item of users" [value]="item.uuid">{{ item.libelle }}</option>
            </select>
          </div>
          <div class="col-md-3">
            <label for="isSigned">Signature numérique du dossier ? <span class="asterix">*</span></label>
            <select class="form-control" id="isSigned" formControlName="isSigned" [ngClass]="{
                'is-invalid': submit && f.isSigned.errors,
                'is-valid': submit && f.isSigned.valid
              }">
              <option *ngFor="let item of booleanRow" [ngValue]="item.value">{{item.label}}</option>
            </select>
            <div class="invalid-feedback" *ngIf="submit && f.isSigned.errors">
              <div *ngIf="f.isSigned.errors.required">{{required.novide}}</div>
            </div>
          </div>
          <div class="col-md-3">
            <label for="isConjoint">Dossier conjoint ?</label>
            <select class="form-control" id="isConjoint" formControlName="isConjoint">
              <option *ngFor="let item of booleanRow" [ngValue]="item.value">{{item.label}}</option>
            </select>
          </div>
          <div class="col-md-3">
            <label for="datelivraison">Date de livraison <span class="asterix">*</span></label>
            <input type="date" (ngModelChange)="addEcheanceFolder()" formControlName="datelivraison" class="form-control" id="datelivraison" [ngClass]="{
              'is-invalid': submit && f.datelivraison.errors,
              'is-valid': submit && f.datelivraison.valid
            }">
            <div class="invalid-feedback" *ngIf="submit && f.datelivraison.errors">
              <div *ngIf="f.datelivraison.errors.required">{{required.novide}}</div>
            </div>
          </div>
          <div class="col-md-3">
            <label for="dateprevision">Date prévisionnelle<span class="asterix">*</span></label>
            <input type="date" (ngModelChange)="addEcheanceFolder()" formControlName="dateprevision" class="form-control" id="dateprevision" [ngClass]="{
              'is-invalid': submit && f.dateprevision.errors,
              'is-valid': submit && f.dateprevision.valid
            }">
            <div class="invalid-feedback" *ngIf="submit && f.dateprevision.errors">
              <div *ngIf="f.dateprevision.errors.required">{{required.novide}}</div>
            </div>
          </div>
          <div class="col-md-3">
            <label for="delai">Delai<span class="asterix">*</span></label>
            <input type="number" (ngModelChange)="addEcheanceFolder()" formControlName="delai" class="form-control" id="delai" [ngClass]="{
              'is-invalid': submit && f.delai.errors,
              'is-valid': submit && f.delai.valid
            }">
          </div>
          <div class="col-md-3">
            <label for="delailimite">Delai limite<span class="asterix">*</span></label>
            <input type="number" (ngModelChange)="addEcheanceFolder()" formControlName="delailimite" class="form-control" id="delailimite" [ngClass]="{
              'is-invalid': submit && f.datelimite.errors,
              'is-valid': submit && f.datelimite.valid
            }">
          </div>
          <!-- ✅ PROMOTION CORRIGÉE -->
          <div (change)="onChangePromotion($event)" *ngIf="f.motif.value === 'MAISON'" class="col-md-3">
            <label for="promotion">
              Programme <span class="asterix"></span>
            </label>
            <ng-select
              
              [(ngModel)]="selectedPromotion"
              [ngModelOptions]="{standalone: true}"
              class="form-control custom-ng-select"
              [items]="promotions"
              bindLabel="libelle"
              bindValue="uuid"
              id="promotion"
              (change)="onChangePromotion($event)"
              placeholder="Sélectionnez un programme">
              <ng-option *ngFor="let item of promotions" [value]="item.uuid">{{item.libelle}}</ng-option>
            </ng-select>
          </div>
          <!-- ✅ SOUS PROMOTION CORRIGÉE -->
          <div *ngIf="f.motif.value === 'MAISON'" class="col-md-3">
            <label for="souspromotion">
              Sous Programme <span class="asterix"></span>
            </label>
            <ng-select
              [(ngModel)]="selectedSousPromotion"
              [ngModelOptions]="{standalone: true}"
              class="form-control custom-ng-select" 
              [items]="sousPromotions" 
              bindLabel="libelle"
              bindValue="uuid" 
              id="souspromotion" 
              (change)="onChangeSousPromotion($event)"
              placeholder="Sélectionnez un sous-programme">
              <ng-option *ngFor="let item of sousPromotions" [value]="item.uuid">{{item.libelle}}</ng-option>
            </ng-select>
          </div>
          <div class="col-md-3">
            <label for="dateentree">Date d'entrée</label>
            <input type="date" (ngModelChange)="addEcheanceFolder()" formControlName="dateentree" class="form-control" id="dateentree">
          </div>
          <div class="col-md-3" *ngIf="f.modalite.value === 'ECHEANCE' || f.modalite.value === 'COMPTANT'">
            <label for="dateDebutFacturation">Date de début de facturation</label>
            <input type="date" (ngModelChange)="addEcheanceFolder()" formControlName="dateDebutFacturation"
              class="form-control" id="dateDebutFacturation">
          </div>
          <div class="col-md-3">
            <label for="caution">Caution</label>
            <input type="number" (ngModelChange)="addEcheanceFolder()" formControlName="caution" class="form-control" id="caution">
          </div>
          <div class="col-md-4">
            <label for="typeContrat">Type de contrat<span class="asterix">*</span></label>
            <select (change)="onSelectType($event)" class="form-control" id="typeContrat" formControlName="typeContrat">
              <option [value]="'LOCATION_ACCESSION_OPT_ECO'">Location-accession concernant les logements économiques</option>
              <option [value]="'LOCATION_ACCESSION_OPT_SOC'">Location-accession concernant les logements sociaux</option>
              <option [value]="'RESERVATION_VENTE_DIRECTE'">Contrat de réservation</option>
              <option [value]="'PRELIMINAIRE_LOCATION_ACCESSION_OPT_ECO'">Préliminaire à un contrat de location-accession concernant les logements économiques</option>
              <option [value]="'PRELIMINAIRE_LOCATION_ACCESSION_OPT_SOC'">Préliminaire à un contrat de location-accession concernant les logements sociaux</option>
            </select>
          </div>
        </div>
      </div>

      <!-- OPTIONS DES BIENS -->
      <div formArrayName="optionHouses" *ngIf="optionHouses.length > 0">
        <div class="form-group">
          <div class="row">
            <div class="col-md-12">
              <label>Désignation </label>
            </div>
            <div class="col-md-4">
              <label>Prix unitaire</label>
            </div>
            <div class="col-md-1">
              <label>Quantité</label>
            </div>
            <div class="col-md-1">
              <label>TVA</label>
            </div>
            <div class="col-md-4">
              <label>Remise</label>
            </div>
            <div class="col-md-2">
              <label>Total</label>
            </div>
          </div>
        </div>
        <div class="form-group" *ngFor="let item of optionHouses.controls; let i=index" [formGroupName]="i">
          <div class="row">
            <div class="col-md-12 mb-2">
              <app-entity-finder *ngIf="f.motif.value === 'PROPRIETAIRE' && (!editLocked)" [class]="'House'" id="houseH{{i}}"
                [params]="[{ type: [{disponible : 'VENTE'}], etat: [{etat : 'DISPONIBLE'}] }]" [groups]="['house']"
                [required]="true" (uuid)="setHouseUuid($event, item)" [placeholder]="'Sélectionnez une désignation'">
              </app-entity-finder>
              <app-entity-finder *ngIf="f.motif.value === 'LOT' && (!editLocked)" [class]="'Lot'" id="lotH{{i}}"
                [params]="[{ etat: [{etat : 'DISPONIBLE'}] }]" [groups]="['lot']" [required]="true"
                (uuid)="setLotUuid($event, item)">
              </app-entity-finder>
              <ng-select class="form-control custom-ng-select" *ngIf="f.motif.value === 'MAISON' && (!editLocked)" [items]="homes" bindLabel="searchableTitle"
                bindValue="uuid" id="promotion" (change)="setHomeUuid($event, item)">
                <ng-option *ngFor="let home of homes" [value]="home.uuid">{{home.searchableTitle}}</ng-option>
              </ng-select>
              <input *ngIf="editLocked" type="text" class="form-control p-2" formControlName="label" id="labelH{{i}}" readonly>
            </div>
            <div class="col-md-4 mb-2">
              <input type="number" class="form-control p-2" formControlName="prix" id="prixH{{i}}"
                placeholder="Prix unitaire" readonly>
            </div>
            <div class="col-md-1 mb-2">
              <input type="number" class="form-control p-2" formControlName="qte" id="qteH{{i}}" placeholder="Quantité" readonly>
            </div>
            <div class="col-md-1 mb-2">
              <input type="number" (change)="onChangeTotalOption(item)" class="form-control" formControlName="tva"
                id="tvaH{{i}}" placeholder="TVA">
            </div>
            <div class="col-md-3 mb-2">
              <input type="number" (change)="onChangeTotalOption(item)" class="form-control" formControlName="remise"
                id="remiseH{{i}}" placeholder="Remise">
            </div>
            <div class="col-md-2 mb-2">
              <input type="number" class="form-control p-2 text-danger text-right font-weight-bold" formControlName="total"
                id="totalH{{i}}" step="0.01" placeholder="Montant du bien" readonly>
            </div>
            <div class="col-md-1 mb-2">
              <button [disabled]="editLocked" (click)="onDeleteOptionHouse(i)" type="button" class="btn btn-danger">
                <i class="feather icon-trash"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="!editLocked" class="row mb-2">
        <button class="btn btn-msg-send btn-primary ml-auto" (click)="addOptionHouse()" type="button"> Ajouter <i
            class="fa fa-plus"></i></button>
      </div>
      <!-- FIN OPTIONS DES BIENS -->

      <!-- Détails sur le supplément -->
      <div class="row">
        <span class="badge badge-secondary my-2 f-14 width">
          Détails sur le supplément
        </span>
      </div>
      <div class="form-group">
        <div class="row mb-2">
          <div class="col-md-3">
            <label for="modalite">Modalité <span class="asterix">*</span></label>
            <select (ngModelChange)="onChangeModaliteAvecRecalcul()" class="form-control" id="modalite" formControlName="modalite"
              [ngClass]="{
                'is-invalid': submit && f.modalite.errors,
                'is-valid': submit && f.modalite.valid
              }">
              <option [value]="'ECHEANCE'">État de paiement échéancier</option>
              <option [value]="'ECHEANCE_ANNUEL'">Échéancier annuel</option>
              <option [value]="'AVANCEMENT'">Taux de progression financier VFA</option>
              <option [value]="'COMPTANT'">Comptant</option>
            </select>
            <div class="invalid-feedback" *ngIf="submit && f.modalite.errors">
              <div *ngIf="f.modalite.errors.required">{{required.novide}}</div>
            </div>
          </div>
          <div class="col-md-3">
            <label for="montantFrais">Frais d'ouverture <span class="asterix">*</span></label>
            <input (ngModelChange)="onChangeTotal()" type="number" formControlName="montantFrais" class="form-control"
              id="montantFrais" [ngClass]="{
              'is-invalid': submit && f.montantFrais.errors,
              'is-valid': submit && f.montantFrais .valid
            }">
            <div class="invalid-feedback" *ngIf="submit && f.montantFrais.errors">
              <div *ngIf="f.montantFrais.errors.required">{{required.novide}}</div>
              <div *ngIf="f.montantFrais.errors.pattern">{{required.nolettre}}</div>
              <div *ngIf="f.montantFrais.errors.pattern">{{required.positive}}</div>
            </div>
          </div>
          <div class="col-md-3">
            <label for="montantAvance">Apport initial <span class="asterix">*</span></label>
            <input (ngModelChange)="onChangeTotal()" type="number" formControlName="montantAvance" class="form-control"
              id="montantAvance" [ngClass]="{
              'is-invalid': submit && f.montantAvance.errors,
              'is-valid': submit && f.montantAvance .valid
            }">
            <div class="invalid-feedback" *ngIf="submit && f.montantAvance.errors">
              <div *ngIf="f.montantAvance.errors.required">{{required.novide}}</div>
              <div *ngIf="f.montantAvance.errors.pattern">{{required.nolettre}}</div>
              <div *ngIf="f.montantAvance.errors.pattern">{{required.positive}}</div>
            </div>
          </div>
          <!-- CHAMP CHARGES MENSUELLES -->
          <div class="col-md-3" *ngIf="f.modalite.value === 'ECHEANCE' || f.modalite.value === 'ECHEANCE_ANNUEL' || f.modalite.value === 'COMPTANT'">
            <label for="montantCharge">
              <span>Charges mensuelles</span>
            </label>
            <input (ngModelChange)="onChangeTotal()" type="number" formControlName="montantCharge" class="form-control"
              id="montantCharge" placeholder="Charges mensuelles" [ngClass]="{
              'is-invalid': submit && f.montantCharge.errors,
              'is-valid': submit && f.montantCharge.valid
            }">
            <div class="invalid-feedback" *ngIf="submit && f.montantCharge.errors">
              <div *ngIf="f.montantCharge.errors.pattern">{{required.nolettre}}</div>
              <div *ngIf="f.montantCharge.errors.min">{{required.positive}}</div>
            </div>
          </div>
          <div class="col-md-4" *ngIf="f.modalite.value === 'ECHEANCE'">
            <label for="nbrMois">Nombre de mois </label>
            <input (ngModelChange)="addEcheanceFolder()" type="number" formControlName="nbrMois" class="form-control"
              id="nbrMois" [ngClass]="{
              'is-invalid': submit && f.nbrMois.errors,
              'is-valid': submit && f.nbrMois .valid
            }">
            <div class="invalid-feedback" *ngIf="submit && f.nbrMois.errors">
              <div *ngIf="f.nbrMois.errors.required">{{required.novide}}</div>
              <div *ngIf="f.nbrMois.errors.pattern">{{required.nolettre}}</div>
              <div *ngIf="f.nbrMois.errors.pattern">{{required.positive}}</div>
            </div>
          </div>
          <div class="col-md-4" *ngIf="f.modalite.value === 'ECHEANCE'">
            <label for="taux">Taux d'intérêt annuel (%)</label>
            <input (ngModelChange)="onChangeTauxOuDuree()" type="number" formControlName="taux" class="form-control"
              id="taux" step="0.01" [ngClass]="{
              'is-invalid': submit && f.taux.errors,
              'is-valid': submit && f.taux.valid
            }">
            <div class="invalid-feedback" *ngIf="submit && f.taux.errors">
              <div *ngIf="f.taux.errors.required">{{required.novide}}</div>
              <div *ngIf="f.taux.errors.pattern">{{required.nolettre}}</div>
            </div>
          </div>
          <!-- CHAMPS ÉCHÉANCIER ANNUEL -->
          <div class="col-md-4" *ngIf="f.modalite.value === 'ECHEANCE_ANNUEL'">
            <label for="nbrMois">Nombre d'années</label>
            <input (ngModelChange)="addEcheanceAnnuelFolder()" type="number" formControlName="nbrMois" class="form-control"
              id="nbrAnnees" min="1" max="30" step="1" [ngClass]="{
              'is-invalid': submit && f.nbrMois.errors,
              'is-valid': submit && f.nbrMois.valid
            }">
          </div>
          <div class="col-md-4" *ngIf="f.modalite.value === 'ECHEANCE_ANNUEL'">
            <label for="taux">Taux d'intérêt annuel (%)</label>
            <input (ngModelChange)="addEcheanceAnnuelFolder()" type="number" formControlName="taux" class="form-control"
              step="0.5" min="0" [ngClass]="{
              'is-invalid': submit && f.taux.errors,
              'is-valid': submit && f.taux.valid
            }">
            <small class="text-muted">0 pour sans intérêts</small>
          </div>
        </div>

        <!-- TYPE D'ÉCHÉANCIER (CONSTANT / PROGRESSIF) -->
        <div class="row" *ngIf="f.modalite.value === 'ECHEANCE'">
          <div class="col-md-4">
            <label for="typeEcheancier">Type d'échéancier</label>
            <select (ngModelChange)="addEcheanceFolder()" class="form-control" id="typeEcheancier" formControlName="typeEcheancier">
              <option [value]="'CONSTANT'">Mensualités constantes</option>
              <option [value]="'PROGRESSIF'">Loyers progressifs</option>
            </select>
          </div>
          <div class="col-md-4" *ngIf="f.typeEcheancier.value === 'PROGRESSIF'">
            <label for="tauxProgression">Progression (%)</label>
            <input (ngModelChange)="addEcheanceFolder()" type="number" formControlName="tauxProgression"
              class="form-control" id="tauxProgression" step="0.01" min="0" max="1">
            <small class="text-muted">Ex: 0.10 = +10%</small>
          </div>
          <div class="col-md-4" *ngIf="f.typeEcheancier.value === 'PROGRESSIF'">
            <label for="intervalleProgression">Intervalle (mois)</label>
            <input (ngModelChange)="addEcheanceFolder()" type="number" formControlName="intervalleProgression"
              class="form-control" id="intervalleProgression" min="1">
            <small class="text-muted">Ex: 60 = tous les 5 ans</small>
          </div>
        </div>
      </div>

      <!-- INFORMATIONS ÉCHÉANCIER ANNUEL -->
      <div class="row" *ngIf="f.modalite.value === 'ECHEANCE_ANNUEL' && mensualiteConstante > 0">
        <span class="badge badge-info my-2 f-14 width">
          Informations échéancier annuel
        </span>
      </div>
      <div class="form-group" *ngIf="f.modalite.value === 'ECHEANCE_ANNUEL' && mensualiteConstante > 0">
        <div class="row mb-2">
          <div class="col-md-12">
            <div class="alert alert-info">
              <h6><i class="fas fa-calendar-alt"></i> Détail de l'échéancier annuel</h6>
              <div class="row">
                <div class="col-md-3">
                  <strong>Nombre d'années :</strong><br>
                  <span class="text-primary">{{f.nbrMois.value}} ans</span>
                </div>
                <div class="col-md-3">
                  <strong>Taux d'intérêt annuel :</strong><br>
                  <span class="text-primary">{{f.taux.value}}%</span>
                </div>
                <div class="col-md-3">
                  <strong>Capital à amortir :</strong><br>
                  <span class="text-success">{{(f.montant.value - f.montantAvance.value) | number}} F CFA</span>
                </div>
                <div class="col-md-3">
                  <strong>Annuité :</strong><br>
                  <span class="text-danger font-weight-bold h5">{{mensualiteConstante | number}} F CFA</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- INFORMATIONS D'AMORTISSEMENT -->
      <div class="row" *ngIf="f.modalite.value === 'ECHEANCE' && mensualiteConstante > 0">
        <span class="badge badge-info my-2 f-14 width">
          Informations d'amortissement calculées
        </span>
      </div>
      <div class="form-group" *ngIf="f.modalite.value === 'ECHEANCE' && mensualiteConstante > 0">
        <div class="row mb-2">
          <div class="col-md-12">
            <div class="alert alert-info">
              <h6><i class="fas fa-calculator"></i> Détail du calcul d'amortissement</h6>
              <div class="row">
                <div class="col-md-3">
                  <strong>Type de contrat :</strong><br>
                  <span class="text-primary">{{f.typeContrat.value}}</span>
                </div>
                <div class="col-md-3">
                  <strong>Taux d'intérêt annuel :</strong><br>
                  <span class="text-primary">{{f.taux.value}}%</span>
                </div>
                <div class="col-md-3">
                  <strong>Durée :</strong><br>
                  <span class="text-primary">{{f.nbrMois.value}} mois ({{(f.nbrMois.value/12).toFixed(1)}} ans)</span>
                </div>
                <div class="col-md-3">
                  <strong>Capital à amortir :</strong><br>
                  <span class="text-success">{{(f.montant.value - f.montantAvance.value) | number}} F CFA</span>
                </div>
              </div>
              <hr>
              <div class="row">
                <div class="col-md-4">
                  <strong>Mensualité de base calculée :</strong><br>
                  <span class="text-warning font-weight-bold h6">{{(mensualiteConstante - (f.montantCharge.value || 0)) | number}} F CFA</span>
                  <br><small class="text-muted">(Capital + Intérêts)</small>
                </div>
                <div class="col-md-4">
                  <strong>Charges mensuelles :</strong><br>
                  <span class="text-info font-weight-bold h6">{{(f.montantCharge.value || 0) | number}} F CFA</span>
                  <br><small class="text-muted">(Frais additionnels)</small>
                </div>
                <div class="col-md-4">
                  <strong>Mensualité totale :</strong><br>
                  <span class="text-danger font-weight-bold h5">{{mensualiteConstante | number}} F CFA</span>
                  <br><small class="text-muted">(Base + Charges)</small>
                </div>
              </div>
              <!-- Info progressif -->
              <div class="row mt-2" *ngIf="f.typeEcheancier.value === 'PROGRESSIF' && loyerProgressifInitial > 0">
                <div class="col-md-12">
                  <div class="alert alert-warning mb-0 py-2">
                    <i class="fas fa-chart-line"></i>
                    <strong> Loyer progressif initial :</strong>
                    <span class="h6 font-weight-bold">{{loyerProgressifInitial | number}} F CFA</span>
                    <span class="text-muted"> (+{{(f.tauxProgression.value * 100)}}% tous les {{(f.intervalleProgression.value / 12)}} ans)</span>
                  </div>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-md-6">
                  <strong>Total des paiements :</strong><br>
                  <span class="text-success font-weight-bold">{{(mensualiteConstante * f.nbrMois.value) | number}} F CFA</span>
                </div>
                <div class="col-md-6">
                  <strong>Débit mensuel (capital) :</strong><br>
                  <span class="text-warning font-weight-bold">{{((f.montant.value - f.montantAvance.value) / f.nbrMois.value) | number}} F CFA</span>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-md-12">
                  <button type="button" class="btn btn-outline-info btn-sm" (click)="afficherDetailAmortissement()">
                    <i class="fas fa-table"></i> Voir le tableau d'amortissement complet
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- OPTION DU DOSSIER -->
      <div class="row">
        <span *ngIf="options.length > 0" class="badge badge-secondary my-2 f-14 width">
          Options supplémentaires au dossier
        </span>
      </div>
      <div formArrayName="optionFolders" *ngIf="options.length > 0">
        <div class="form-group">
          <div class="row">
            <div class="col-md-3">
              <label>Désignation </label>
            </div>
            <div class="col-md-2">
              <label>Prix unitaire</label>
            </div>
            <div class="col-md-1">
              <label>Quantité</label>
            </div>
            <div class="col-md-1">
              <label>Tva</label>
            </div>
            <div class="col-md-2">
              <label>Remise</label>
            </div>
            <div class="col-md-2">
              <label>Total</label>
            </div>
          </div>
        </div>
        <div class="form-group" *ngFor="let item of options.controls; let i=index" [formGroupName]="i">
          <div class="row">
            <div class="col-md-3">
              <input type="text" class="form-control p-2" formControlName="libelle" id="libelle{{i}}" [ngClass]="{
                  'is-invalid': submit && item.get('libelle').errors,
                  'is-valid': submit && item.get('libelle').valid
                }" placeholder="Désignation">
              <div class="invalid-feedback" *ngIf="submit && item.get('libelle').errors">
                <div *ngIf="item.get('libelle').errors.required">{{required.novide}}</div>
              </div>
            </div>
            <div class="col-md-2">
              <input type="number" (change)="onChangeTotalOption(item)" class="form-control" formControlName="prix"
                [ngClass]="{
                  'is-invalid': submit && item.get('prix').errors,
                  'is-valid': submit && item.get('prix').valid
                }" id="prix{{i}}" placeholder="Prix unitaire">
              <div class="invalid-feedback" *ngIf="submit && item.get('prix').errors">
                <div *ngIf="item.get('prix').errors.required">{{required.novide}}</div>
              </div>
            </div>
            <div class="col-md-1">
              <input type="number" (change)="onChangeTotalOption(item)" class="form-control" formControlName="qte"
                id="qte{{i}}" placeholder="Quantité">
            </div>
            <div class="col-md-1">
              <input type="number" (change)="onChangeTotalOption(item)" class="form-control" formControlName="tva"
                id="tva{{i}}" placeholder="TVA">
            </div>
            <div class="col-md-2">
              <input type="number" (change)="onChangeTotalOption(item)" class="form-control" formControlName="remise"
                id="remise{{i}}" placeholder="Remise">
            </div>
            <div class="col-md-2">
              <input type="text" class="form-control p-2 text-danger font-weight-bold" formControlName="total"
                id="total{{i}}" readonly>
            </div>
            <div class="col-md-1">
              <button (click)="onDeleteOptions(i)" type="button" class="btn btn-danger">
                <i class="feather icon-trash"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-2">
        <button class="btn btn-msg-send btn-primary ml-auto" (click)="addOption()" type="button"> Ajouter <i
            class="fa fa-plus"></i></button>
      </div>
      <!-- FIN OPTION DU DOSSIER -->

      <!-- DEBUT L'ECHEANCIER -->
      <div class="row" *ngIf="f.nbrMois.value > 0 && f.montant.value > 0 && echeanceFolders.length > 0">
        <span class="badge badge-secondary my-2 f-14 width">
          Détails sur l'état de paiement des échéancier
        </span>
      </div>
      <div formArrayName="echeanceFolders" *ngIf="echeanceFolders.length > 0">
        <div class="form-group">
          <div class="row">
            <div class="col-md-2">
              <label>Date</label>
            </div>
            <div class="col-md-2">
              <label>Mensualité base</label>
            </div>
            <div class="col-md-2" *ngIf="f.modalite.value === 'ECHEANCE'">
              <label>Charges</label>
            </div>
            <div class="col-md-2">
              <label>Montant total</label>
            </div>
            <div [ngClass]="f.modalite.value === 'ECHEANCE' ? 'col-md-2' : 'col-md-4'">
              <label>Description</label>
            </div>
            <div class="col-md-2" *ngIf="f.modalite.value === 'ECHEANCE' || f.modalite.value === 'ECHEANCE_ANNUEL'">
              <label>Capital restant</label>
            </div>
          </div>
        </div>
        <div class="form-group" *ngFor="let item of echeanceFolders.controls; let i=index" [formGroupName]="i">
          <div class="row">
            <div class="col-md-2">
              <input type="text" class="form-control p-2 text-secondary font-weight-bold" formControlName="date"
                id="date{{i}}" placeholder="Date" readonly>
            </div>
            <!-- NOUVEAU CHAMP: Mensualité de base -->
            <div class="col-md-2">
              <input type="text" class="form-control p-2 text-success font-weight-bold" formControlName="mensualiteBase"
                id="mensualiteBase{{i}}" [value]="(item.get('mensualiteBase').value || 0) | number" readonly>
            </div>
            <!-- Champ charges -->
            <div class="col-md-2" *ngIf="f.modalite.value === 'ECHEANCE'">
              <input type="number" class="form-control p-2 text-info font-weight-bold" formControlName="charge"
                id="charge{{i}}" placeholder="Charges" readonly>
            </div>
            <!-- Montant total -->
            <div class="col-md-2">
              <input type="text" class="form-control p-2 text-danger font-weight-bold" formControlName="montant"
                id="montant{{i}}" placeholder="Montant total" readonly>
            </div>
            <div [ngClass]="f.modalite.value === 'ECHEANCE' ? 'col-md-2' : 'col-md-4'">
              <input type="text" class="form-control" formControlName="description" id="description{{i}}">
            </div>
            <div class="col-md-2" *ngIf="f.modalite.value === 'ECHEANCE' || f.modalite.value === 'ECHEANCE_ANNUEL'">
              <input type="text" class="form-control p-2 text-muted font-weight-bold" formControlName="capitalRestant"
                id="capitalRestant{{i}}" readonly>
            </div>
          </div>
        </div>
        
        <!-- RÉSUMÉ DÉTAILLÉ DE L'ÉCHÉANCIER D'AMORTISSEMENT AVEC CHARGES -->
        <div class="row" *ngIf="f.modalite.value === 'ECHEANCE' && tableauAmortissement.length > 0">
          <div class="col-md-12">
            <div class="alert alert-light border">
              <h6><i class="fas fa-chart-line"></i> Résumé détaillé de l'amortissement</h6>
              <div class="row">
                <div class="col-md-3">
                  <small class="text-muted">Apport initial :</small><br>
                  <strong class="text-info">{{f.montantAvance.value | number}} F CFA</strong>
                </div>
                <div class="col-md-3">
                  <small class="text-muted">Total mensualités de base :</small><br>
                  <strong class="text-success">{{((mensualiteConstante - (f.montantCharge.value || 0)) * f.nbrMois.value) | number}} F CFA</strong>
                  <br><small class="text-muted">(Capital + Intérêts uniquement)</small>
                </div>
                <div class="col-md-3">
                  <small class="text-muted">Total charges :</small><br>
                  <strong class="text-info">{{((f.montantCharge.value || 0) * f.nbrMois.value) | number}} F CFA</strong>
                  <br><small class="text-muted">({{f.montantCharge.value || 0 | number}} × {{f.nbrMois.value}} mois)</small>
                </div>
                <div class="col-md-3">
                  <small class="text-muted">Total à payer :</small><br>
                  <strong class="text-danger">{{(mensualiteConstante * f.nbrMois.value) | number}} F CFA</strong>
                  <br><small class="text-muted">(Base + Charges)</small>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-md-6">
                  <small class="text-muted">Coût du crédit (intérêts uniquement) :</small><br>
                  <strong class="text-warning">{{(((mensualiteConstante - (f.montantCharge.value || 0)) * f.nbrMois.value) - (f.montant.value - f.montantAvance.value)) | number}} F CFA</strong>
                </div>
                <div class="col-md-6">
                  <small class="text-muted">Total général (Apport + Mensualités) :</small><br>
                  <strong class="text-primary">{{(f.montantAvance.value + (mensualiteConstante * f.nbrMois.value)) | number}} F CFA</strong>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- FIN L'ECHEANCIER -->

      <!-- DEBUT L'AVANCEMENT -->
      <div class="row" *ngIf="avanceFolders.length > 0">
        <span class="badge badge-secondary my-2 f-14 width">
          Détails sur le taux de progression financier VFA
        </span>
      </div>
      <div formArrayName="avanceFolders" *ngIf="avanceFolders.length > 0">
        <div class="form-group">
          <div class="row">
            <div class="col-md-3">
              <label>Libellé </label>
            </div>
            <div class="col-md-3">
              <label>Pourcentage (%)</label>
            </div>
            <div class="col-md-6">
              <label>Montant</label>
            </div>
          </div>
        </div>
        <div class="form-group" *ngFor="let item of avanceFolders.controls; let i=index" [formGroupName]="i">
          <div class="row">
            <div class="col-md-3">
              <input type="text" class="form-control p-2 text-secondary font-weight-bold" formControlName="libelle"
                id="libelle{{i}}" placeholder="Libellé">
            </div>
            <div class="col-md-3">
              <input type="number" (change)="setPourcentage(item)"
                class="form-control p-2 text-secondary font-weight-bold" formControlName="prc" id="prc{{i}}"
                placeholder="Pourcentage (%)">
            </div>
            <div class="col-md-6">
              <input type="text" class="form-control" formControlName="montant" id="montant{{i}}">
            </div>
          </div>
        </div>
      </div>
      <!-- FIN L'AVANCEMENT -->

      <!-- RESUME DES MONTANTS - MODIFIÉ -->
      <div class="row">
        <div class="col-sm-12">
          <table class="table table-responsive invoice-table invoice-total">
            <tbody>
              <tr *ngIf="f.modalite.value !== 'ECHEANCE'">
                <th>Total HT :</th>
                <td>{{ totalHt | number}}</td>
              </tr>
              <tr *ngIf="f.modalite.value !== 'ECHEANCE'">
                <th>Total remise :</th>
                <td>{{ totalRemise | number}}</td>
              </tr>
              <tr *ngIf="f.modalite.value !== 'ECHEANCE'">
                <th>Total TVA :</th>
                <td>{{ totalTva | number}}</td>
              </tr>
              <tr class="text-info">
                <td>
                  <hr />
                  <h2 class="text-primary m-r-10">Total ttc à verser :</h2>
                </td>
                <td>
                  <hr />
                  <h2 class="text-success">{{ totalTtc|number}}</h2>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="row">
        <span class="badge badge-secondary my-2 f-14 width"> Quelques documents supplémentaires </span>
      </div>
      <div class="form-group">
        <div class="row mb-2">
          <div class="col-md">
            <label>Pièces et documents à joindre</label>
            <app-folder-uploader (filesd)="files($event)" [maxSize]="50" (filesUploaded)="setParam('folderUuid',$event)"
              [path]="'dossier'" [etat]="edit ? 'edit': 'add'" [folder]="edit && folder ? folder?.folder : null">
            </app-folder-uploader>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button (click)="onClose()" type="button" class="btn btn-secondary text-left" data-dismiss="modal">
      Fermer <i class="feather icon-x-circle"></i>
    </button>
    <button [disabled]="edit" (click)="form.reset()" type="button" class="btn btn-warning">
      Vider <i class="fas fa-broom"></i>
    </button>
    <button [disabled]="form.invalid" type="submit" class="btn btn-primary">
      Enregistrer <i class="feather icon-save"></i>
    </button>
  </div>
</form>